(function(){
  var root = document.getElementById('pm-promo');
  if(!root) return;

  var STORAGE_KEY = 'pm_promo_dismissed';
  var DELAY_MS = 1000;

  // localStorage puede fallar (modo privado, datos bloqueados): nunca debe romper la página
  function storageGet(){ try{ return localStorage.getItem(STORAGE_KEY); }catch(e){ return null; } }
  function storageSet(){ try{ localStorage.setItem(STORAGE_KEY, '1'); }catch(e){} }

  // Si ya lo cerró o lo usó antes en este navegador, no lo mostramos de nuevo
  if(storageGet()) return;

  var bubble = root.querySelector('.pm-promo-bubble');
  var overlay = root.querySelector('.pm-promo-overlay');
  var closeBtn = root.querySelector('.pm-promo-close');
  var getBtn = root.querySelector('.pm-promo-btn');
  var titleEl = root.querySelector('.pm-promo-title');

  // Blindaje extra: fuerza el color por JS por si el CSS del theme
  // trae su propio !important sobre el texto del richtext.
  if(titleEl){
    titleEl.style.setProperty('color', '#f0e9d8', 'important');
    titleEl.style.setProperty('opacity', '1', 'important');
    titleEl.style.setProperty('filter', 'none', 'important');
    titleEl.style.setProperty('mix-blend-mode', 'normal', 'important');
    titleEl.style.setProperty('text-shadow', 'none', 'important');
    titleEl.style.setProperty('-webkit-text-fill-color', '#f0e9d8', 'important');
    titleEl.querySelectorAll('*').forEach(function(node){
      var tag = node.tagName.toLowerCase();
      var color = (tag === 'b' || tag === 'strong') ? '#e8202f' : '#f0e9d8';
      node.style.setProperty('color', color, 'important');
      node.style.setProperty('opacity', '1', 'important');
      node.style.setProperty('filter', 'none', 'important');
      node.style.setProperty('mix-blend-mode', 'normal', 'important');
      node.style.setProperty('text-shadow', 'none', 'important');
      node.style.setProperty('-webkit-text-fill-color', color, 'important');
    });
  }

  var code = root.getAttribute('data-code') || 'BIENVENIDO10';
  var redirectUrl = root.getAttribute('data-redirect-url') || '/collections/catalogo';

  var codeBtn = root.querySelector('#pm-promo-code-btn');
  var copyHint = root.querySelector('#pm-promo-copyhint');
  var lastFocus = null;

  function dismissForever(){
    storageSet();
  }

  function openModal(){
    lastFocus = document.activeElement;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pm-promo-lock');
    if(closeBtn) setTimeout(function(){ closeBtn.focus({ preventScroll: true }); }, 60);
    // Celebración al abrir el regalo
    if(window.PMFx){
      setTimeout(function(){
        var card = root.querySelector('.pm-promo-card');
        if(!card) return;
        var r = card.getBoundingClientRect();
        window.PMFx.confetti(r.left + r.width / 2, r.top + 70, 60);
      }, 220);
    }
  }

  function closeModal(){
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pm-promo-lock');
    if(lastFocus && lastFocus.focus){ try{ lastFocus.focus({ preventScroll: true }); }catch(e){} }
  }

  function copyCode(){
    if(navigator.clipboard && navigator.clipboard.writeText){
      navigator.clipboard.writeText(code).catch(function(){});
    }
  }

  // Click en el código = copiarlo (sin cerrar el modal)
  if(codeBtn){
    codeBtn.addEventListener('click', function(){
      copyCode();
      codeBtn.classList.add('is-copied');
      if(copyHint) copyHint.textContent = '¡Código copiado!';
      setTimeout(function(){
        codeBtn.classList.remove('is-copied');
        if(copyHint) copyHint.textContent = 'Toca el código para copiarlo';
      }, 1800);
    });
  }

  setTimeout(function(){
    bubble.classList.remove('is-hidden');
  }, DELAY_MS);

  function openFromBubble(){
    bubble.classList.add('is-hidden');
    openModal();
  }
  bubble.addEventListener('click', openFromBubble);
  bubble.addEventListener('keydown', function(e){
    if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); openFromBubble(); }
  });

  // Click fuera de la tarjeta = cerrar
  overlay.addEventListener('click', function(e){
    if(e.target === overlay){ closeModal(); dismissForever(); }
  });

  closeBtn.addEventListener('click', function(){
    closeModal();
    dismissForever();
  });

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && overlay.classList.contains('is-open')){
      closeModal();
      dismissForever();
    }
  });

  getBtn.addEventListener('click', function(){
    dismissForever();
    copyCode();

    getBtn.textContent = '¡Código copiado! Redirigiendo...';
    getBtn.classList.add('is-copied');

    setTimeout(function(){
      window.location.href = redirectUrl;
    }, 900);
  });
})();